import { createSlice } from '@reduxjs/toolkit';
import { TariffFormValues } from '../../types';

export interface TariffsCreateFormState {
  formValues?: TariffFormValues;
}

const initialState: TariffsCreateFormState = {};

export const tariffsCreateFormSlice = createSlice({
  name: 'tariffsCreateForm',
  initialState,
  reducers: {
    clearTariffsCreateFormState: (state) => {
      state.formValues = undefined;
    },
  },
});

export const { clearTariffsCreateFormState } = tariffsCreateFormSlice.actions;

export default tariffsCreateFormSlice.reducer;
